var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.9V16.1C15 19.6 13.6 21 10.1 21H5.9C2.4 21 1 19.6 1 16.1V11.9C1 8.4 2.4 7 5.9 7H10.1C13.6 7 15 8.4 15 11.9Z",
    stroke: "#8F8F8F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 5.9V10.1C21 13.6 19.6 15 16.1 15H15V11.9C15 8.4 13.6 7 10.1 7H7V5.9C7 2.4 8.4 1 11.9 1H16.1C19.6 1 21 2.4 21 5.9Z",
    stroke: "#8F8F8F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.c740921448d52e1b69209f7c67dca9de.svg";
export { ForwardRef as ReactComponent };